import {get} from "lodash"
import BaseService from "./Base"
import {PhaseDurationUnit} from "types/program-version-phases-and-shifts-templates"

export default class ProgramVersionPhasesAndShiftsTemplatesService extends BaseService {
    addNewPhaseTemplate = async (data: {phaseId: number; programVersionId: number}): Promise<any> => {
        const response = await this.post("/v1/program-version/create-new-phase-template", data)
        return get(response, "data.data", {})
    }

    editPhaseTemplate = async (data: {
        phaseTemplates: Array<{
            programVersionPhaseShiftTemplateId: number
            phaseId?: number
            position?: number
            durationUnit?: PhaseDurationUnit
            duration?: number
        }>
    }): Promise<any> => {
        const response = await this.post("/v1/program-version/edit-phase-template", data)
        return get(response, "data.data", {})
    }

    deletePhaseTemplate = async (data: {programVersionPhaseShiftTemplateIds: number[]}): Promise<any> => {
        const response = await this.post("/v1/program-version/delete-phase-template", data)
        return get(response, "data.data", {})
    }

    getMajorVersionPhaseTemplates = async (params = {}): Promise<any[]> => {
        const response = await this.post("/v1/program-version/get-phase-templates", params)
        return get(response, "data.data", [])
    }

    addShiftTemplate = async (data: {shiftIds: number[]; programVersionPhaseShiftTemplateId: number}) => {
        const response = await this.post("/v1/program-version/add-shift-template", data)
        return get(response, "data.data", {})
    }

    editShiftTemplate = async (data: {
        shiftTemplates: Array<{
            programVersionPhaseShiftTemplateShiftId: number
            programVersionPhaseShiftTemplateId: number
            position: number
        }>
    }) => {
        const response = await this.post("/v1/program-version/edit-shift-template", data)
        return get(response, "data.data", {})
    }

    deleteShiftTemplate = async (data: {programVersionPhaseShiftTemplateShiftIds: number[]}) => {
        const response = await this.post("/v1/program-version/delete-shift-template", data)
        return get(response, "data.data", {})
    }
}
